import { render, staticRenderFns } from "./MarketingCourse.vue?vue&type=template&id=0dc1afc8&scoped=true"
import script from "./MarketingCourse.vue?vue&type=script&lang=js"
export * from "./MarketingCourse.vue?vue&type=script&lang=js"
import style0 from "./MarketingCourse.vue?vue&type=style&index=0&id=0dc1afc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1afc8",
  null
  
)

export default component.exports